(function () {
  if (window.__pwbDates) return;
  window.__pwbDates = true;
  function run() {
    var now = Date.now() / 1000;
    var uls = document.querySelectorAll('ul.pwb-chips[data-pwb-rows]');
    for (var i = 0; i < uls.length; i++) {
      var ul = uls[i];
      var rows = ul.getAttribute('data-pwb-rows').split(';');
      var pick = null;
      for (var j = 0; j < rows.length; j++) {
        var f = rows[j].split('|');
        if (+f[0] > now) { pick = f; break; }
      }
      var ob = ul.querySelector('[data-pwb-k="ob"]');
      var pd = ul.querySelector('[data-pwb-k="pd"]');
      var eta = ul.querySelector('[data-pwb-k="eta"]');
      if (!pick) {
        [ob, pd, eta].forEach(function (e) { if (e) e.parentNode.removeChild(e); });
        ul.removeAttribute('data-pwb-rows');
        continue;
      }
      var t;
      t = 'Order by: ' + pick[1] + ', 11:59 PM Pacific';
      if (ob && ob.textContent !== t) ob.textContent = t;
      t = 'Payment due: ' + pick[2] + ', 5:00 PM Pacific';
      if (pd && pd.textContent !== t) pd.textContent = t;
      t = 'Estimated Time of Arrival: ' + pick[3];
      if (eta && eta.textContent !== t) eta.textContent = t;
    }
    var trs = document.querySelectorAll('tr[data-pwb-ob]');
    for (var k = 0; k < trs.length; k++) {
      if (+trs[k].getAttribute('data-pwb-ob') <= now) trs[k].parentNode.removeChild(trs[k]);
    }
  }
  var timer = null;
  function soon() { if (timer) return; timer = setTimeout(function () { timer = null; run(); }, 50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  try {
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) { if (muts[m].addedNodes.length) { soon(); return; } }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  setInterval(run, 60000);
})();
